import request from '@/services/interceptor.js'


export const get_clienti = (par) => {
  return request({
    url: '/api/agenti/clienti/' + par,
    method: 'get'
  })
};

export const get_clientiAttivi = () => {
  return request({
    url: '/api/agenti/clienti/attivi',
    method: 'get'
  })
};

export const get_mapsClienti = (par) => {
  return request({
    url: '/api/agenti/maps/' + par,
    method: 'get'
  })
};

export const get_mapsProvince = () => {
  return request({
    url: '/api/agenti/maps/prova/province',
    method: 'get'
  })
};

export const get_listaAgenti = () => {
  return request({
    url: '/api/agenti/lista',
    method: 'get',
    noLoadingBar: true
  })
};

export const get_noteClienti = (par) => {
  return request({
    url: '/api/agenti/clienti/note/' + par,
    method: 'get'
  })
};

export const save_noteClienti = (par) => {
  return request({
    url: '/api/agenti/clienti/note/save',
    method: 'post',
    data: par
  })
};

export const delete_noteClienti = (par) => {
  return request({
    url: '/api/agenti/clienti/note/delete/' + par,
    method: 'delete'
  })
};

export const get_schedaAnagrafica = () => {
  return request({
    url: '/api/agenti/clienti/anagrafica/scheda',
    method: 'get'
  })
};

export const upload_fileAnagrafica = (par) => {
  return request({
    url: '/api/agenti/clienti/anagrafica/scheda/upload',
    method: 'post',
    data: par,
    noLoadingBar: true
  })
};

//#region Clienti potenziali

export const get_tipoClienti = () => {
  return request({
    url: '/api/agenti/clienti/anagrafica/potenziale/tipi',
    method: 'get'
  })
};

export const set_clientePotenziale = (par, data) => {
  return request({
    url: '/api/agenti/clienti/anagrafica/potenziale/' + par,
    method: 'post',
    data: data,
    noLoadingBar: true
  })
};

export const get_clientiPotenziali = (par) => {
  return request({
    url: '/api/agenti/clienti/anagrafica/potenziali/' + par,
    method: 'get',
    noLoadingBar: true
  })
};

export const salva_clientiPotenziali = (par, data) => {
  return request({
    url: '/api/agenti/clienti/anagrafica/potenziale/' + par,
    method: 'post',
    data: data,
    noLoadingBar: true
  })
};

export const del_clientiPotenziali = (par, data) => {
  return request({
    url: '/api/agenti/clienti/anagrafica/potenziale/' + par,
    method: 'delete',
    data: data,
    noLoadingBar: true
  })
};

export const segna_esportati_clientiPotenziali = (ids) => {
  return request({
    url: '/api/agenti/clienti/anagrafica/potenziali/segnaEsportati',
    method: 'post',
    data: ids,
    noLoadingBar: true
  })
};
//#endregion